module.exports = __webpack_public_path__ + "static/media/mastercard-logo.7ea6d120.png";